export interface InventoryHistorySearchRequest {
  filters: {
    skuId: number;
    accounts: string[];
    warehouseNames?: string[];
    date?: { from?: string; to?: string };
    time?: { from?: string; to?: string };
  };
  sort?: { field: string; direction: 'ASC' | 'DESC' }[];
  size?: number;
}

export interface InventoryHistoryItem {
  date: string;
  time: string;
  account: string;
  warehouseName: string;
  quantity: number;
}

export interface InventoryHistoryJobResponse {
  jobId?: string;
  status?: 'PENDING' | 'COMPLETED' | 'FAILED';
  content?: InventoryHistoryItem[];
  error?: string;
}

export interface InventoryHistoryJobResult {
  status: 'PENDING' | 'COMPLETED' | 'FAILED';
  content?: InventoryHistoryItem[];
  error?: string;
}

export const WAREHOUSE_OPTIONS = [
  { label: 'Rua A', value: '_A' },
  { label: 'Rua I', value: '_I' },
  { label: 'Rua M', value: '_M' },
  { label: 'Rua P', value: '_P' },
];
